import axios from "axios";

const apiRoot = `${process.env.REACT_APP_API_URL}`;

const client = axios.create({
  baseURL: apiRoot,
});

const request = async (options: {}) => {
  const onSuccess = (response: {}) => {
    console.debug("Request successfull:", response);
    return response;
  };

  const onError = (error: {
    config: {};
    response: { status: string; data: {}; headers: {} };
    message: string;
  }) => {
    console.error("Request failed:", error.config);

    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
      console.error("Headers:", error.response.headers);
    } else {
      // log message if it wasn't based on the response
      console.error("Error Message:", error.message);
    }

    return error.response || error.message;
  };

  const response = await client(options).then(onSuccess).catch(onError);

  return response;
};

export default request;
